import { render, staticRenderFns } from "./AddTrailerPage.vue?vue&type=template&id=4c1a5f4b&scoped=true"
import script from "./AddTrailerPage.vue?vue&type=script&lang=js"
export * from "./AddTrailerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a5f4b",
  null
  
)

export default component.exports